export enum PRODUCT_CATEGORY {
  INDIVIDUAL = 'I',
  GROUP = 'G',
}

export enum PRODUCT_CLASS {
  MOTOR = 'Motor',
  NON_MOTOR = 'Non Motor',
  MEDICAL = 'Medical',
  NON_MEDICAL = 'Non Medical',
  FIRE = 'Fire',
  MARINE = 'Marine',
  MISC = 'Miscellaneous ',
}

export enum COVERAGES {
  INDIVIDUAL = 'I',
  INDIVIDUAL_WITH_FAMILY = 'IWF',
  FAMILY_WITH_PARENTS = 'FP',
  IMMEDIATE_FAMILY = 'IF',
}

export enum DOCUMENT_SETUP_TYPE {
  MANDATORY = 'M',
  OPTIONAL = 'O',
}

export enum DOCUMENT_STAGE {
  QUOTATION = 'Q',
  PROPOSAL = 'P',
  RENEWAL = 'R',
}

export enum FILE_UNIT {
  MB = 'MB',
  GB = 'GB',
}

export enum FILE_FORMATS {
  PDF = 'PDF',
  DOC = 'DOC',
  SVG = 'SVG',
  PNG = 'PNG',
  JPG = 'JPG',
  CSV = 'CSV',
}

export enum REQUIRED_DOC_TYPE_BULK {
  INVOICE = 'Invoice',
  POLICY_SCHEDULE = 'Policy Schedule',
  PAYMENT_RECEIPT = 'Payment Receipt(s)',
  QUOTATION = 'Quotation',
  NIC = 'National Identity Card (NIC)',
  BR = ' Business Registration Document ',
}
